export default __webpack_public_path__ + "static/neeraj-d4d274695af460fc4131a111e797f170.png";